import type { TyreLayout, TyreLayoutInput, TyreLayoutSubjectKind } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

export function getTyreLayout(subjectKind: TyreLayoutSubjectKind, subjectCode: string): Promise<TyreLayout> {
  return api<TyreLayout>(`/tyre-layouts/${subjectKind}/${encodeURIComponent(subjectCode)}`);
}

/** An idempotent full replace of the layout's shape, same as PUT /zones/:id. */
export function saveTyreLayout(subjectKind: TyreLayoutSubjectKind, subjectCode: string, input: TyreLayoutInput): Promise<TyreLayout> {
  return api<TyreLayout>(`/tyre-layouts/${subjectKind}/${encodeURIComponent(subjectCode)}`, { method: 'PUT', body: JSON.stringify(input) });
}

export type { TyreLayout, TyreLayoutInput, TyreLayoutSubjectKind };
